import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../ui/Button';

/**
 * Last-resort screen for an unhandled render error.
 *
 * Deliberately depends on nothing but i18n (registered at module load, not via
 * a provider) so it still renders when the failure came from ThemeProvider,
 * AuthProvider or the router itself.
 */
function AppErrorFallback({ retry }: { retry: () => void }) {
  const { t } = useTranslation('admin');

  return (
    <main className="app-boot">
      <div className="app-boot__card" role="alert">
        <h1 className="app-boot__title">{t('common.errorTitle')}</h1>
        <div className="app-boot__actions">
          <Button onClick={retry}>{t('common.retry')}</Button>
        </div>
      </div>
    </main>
  );
}

export function renderAppErrorFallback(_error: Error, retry: () => void) {
  return <AppErrorFallback retry={retry} />;
}
